
export function useHash ()
{
    const params = new Proxy({hash: window.location.hash},
                   {
                    get: (params, prop) =>
                         {
                            let strHash = params.hash;
                            let arrHash = strHash.split("#").map( h => h.split("="));

                            let hashProp = arrHash.find ( h => h[0]);
                            return hashProp ? hashProp[1] : "";
                         },
                });


    return params;
}
